<template>
  <div class="card playlists-card">
    <div class="card-header clearfix">
      {{ $t('our_playlists') }} 😎 <a target="_blank" href="https://open.spotify.com/user/0prvlevxuj0z0qizh2o7zd5hy/playlists" class="pull-right">{{ $t('view_all_playlists') }}</a>
    </div>
    <div class="card-body p-2">
      <div class="carousel-slider-playlists owl-carousel">
        <div class="item-list" v-for="(playlist, index) in playlists" v-bind:key="`playlist_${index}`">
          <a :href="playlist.external_urls.spotify" target="_blank">
            <img :src="playlist.images[0] && playlist.images[0].url" class="img-fluid">
          </a>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button type="button" class="btn btn-gradient btn-sm" @click="addSong()">
        {{ $t('submit_your_song') }}
      </button>
    </div>
    <UpgradeModal></UpgradeModal>
    <div ref="submitTrackModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title text-dark">
              {{ $t('submit_your_song') }}
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" v-html="$t('indiefy_playlisting_details')">
            </div>
            <div class="form-group" v-if="loading">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
            <div class="form-group" v-if="!loading && songs.length">
              <label for="">{{ $t('song') }}</label>
              <select class="form-control" v-model="selectedSong">
                <option :value="song" v-for="(song, index) in songs" v-bind:key="`song_${index}`">
                  {{ song.text }}
                </option>
              </select>
            </div>
            <div class="form-group" v-if="!loading && !songs.length && user.subscription && user.subscription.plan_name !== 'indiefy_lite'">
              <label for="" class="text-warning">
                {{ $t('zero_published_releases') }}
              </label>
            </div>
            <div class="form-group" v-if="selectedSong.distribution">
              <div class="alert alert-primary">
                {{ $t('indiefy_playlisting_process') }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-dismiss="modal">{{ $t('cancel') }}</button>
            <button type="button" :disabled="!selectedSong.distribution" class="btn btn-primary" @click="submitSong()" v-if="user.subscription && user.subscription.plan_name !== 'indiefy_lite'">
              {{ $t('send') }}
            </button>
            <router-link tag="button" class="btn btn-primary" to="/upgrade?from=playlisting" v-if="!user.subscription || user.subscription.plan_name === 'indiefy_lite'">
              {{ $t('upgrade_to_pro') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Public from '../services/public'
import Distributions from '../services/distributions'
import _ from 'underscore'
import UpgradeModal from '../components/utils/UpgradeModal'

export default {
  name: 'Playlists',
  data: function () {
    return {
      dataLoaded: false,
      loading: false,
      selectedSong: {},
      distributions: [],
      songs: [],
      playlists: []
    }
  },
  methods: {
    submitSong: function () {
      window.$(this.$refs.submitTrackModal).modal('hide')
      Distributions.submitSong(this.selectedSong).then(() => {
        this.$notify({ message: this.$t('request_sent') }, 'success', 'fa-check')
      })
    },
    getData: function () {
      this.loading = true

      if (this.user.subscription && this.user.subscription.plan_name !== 'indiefy_lite' && !this.dataLoaded) {
        Distributions.getAll({ status: 3 }).then(response => {
          this.distributions = response.data

          _.each(this.distributions, distro => {
            _.each(distro.songs, song => {
              let text = `${distro.title} - ${song.title}`

              if (distro.songs.length === 1) {
                text = song.title
              }

              this.songs.push({
                text,
                distribution: distro._id,
                song: song.title
              })
            })
          })

          this.loading = false
          this.dataLoaded = true
        })
      } else {
        this.loading = false
      }
    },
    initCarousel: function () {
      window.$('.carousel-slider-playlists').owlCarousel({
        autoPlay: 3000,
        navigation: false,
        slideSpeed: 500,
        pagination: false,
        paginationSpeed: 1000,
        items: 4,
        loop: true,
        autoHeight: true,
        addClassActive: true,
        goToFirst: true,
        goToFirstSpeed: 200
      })
    },
    addSong: function () {
      this.getData()
      window.$(this.$refs.submitTrackModal).modal('show')
    }
  },
  created: function () {
    this.user = this.$user

    Public.getPlaylists().then(response => {
      this.playlists = response.data

      setTimeout(() => {
        this.initCarousel()
      }, 150)
    })
  },
  components: {
    UpgradeModal
  },
  filters: {
  }
}
</script>
<style lang="scss" scoped>
.playlists-card {
  img {
    border-radius: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Playlists.vue